import { useState } from 'react';

const useInput = (validate) => {
  const [inputs, setInputs] = useState({});
  const [errors, setErrors] = useState({});

  const handleBlur = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
  };

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };

  return {
    handleInputChange,
    handleBlur,
    inputs,
    errors,
  };
};

export { useInput };
